import { Box, Drawer, Grid, DrawerProps, styled } from "@mui/material"
import { IExceptionFilter } from "../../../../Store/Exceptions/types"
import { GridButtons } from "../grid/GridButtons"
import ButtonGradient from "../ButtonGradient"
import ButtonLightGray from "../ButtonLightGray"
import { FilterTitle } from "../FilterTitle"
import FilterDrawerTitle from "../FilterDrawerTitle"
import FilterDrawerMoreTextField from "../FilterDrawerMoreTextField"
import React, { useEffect } from "react"
import FilterTimeRange from "../FilterTimeRange"

const BoxButton = styled(Box)(() => ({
    padding: "5px 5px 5px 5px"
}))

interface IExceptionDrawerMoreFilter extends DrawerProps {
    onFilterApply: (filter: IExceptionFilter) => void,
    resetFilter: () => void,
    filter: IExceptionFilter,
    setFilter: React.Dispatch<React.SetStateAction<IExceptionFilter>>
}

const ExceptionDrawerMoreFilter: React.FC<IExceptionDrawerMoreFilter> = (props) => {

    const [selectedRange, setSelectedRange] = React.useState<string | undefined>(undefined);
    
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            props.onFilterApply(props.filter)
        }
    }

    const handleOnClick = () => {
        props.resetFilter();
        setSelectedRange(undefined);
    }

    useEffect(() => {
        const dateFrom = props.filter.dateLowerBound;
        const dateTo = props.filter.dateUpperBound;

        if ((dateFrom === undefined && dateTo === undefined) && selectedRange !== undefined) {
            setSelectedRange(undefined);
        }
    }, [props.filter, selectedRange]);

    return (
        <Drawer
            anchor={props.anchor}
            open={props.open}
            onClose={props.onClose}
            style={{position: "relative"}}
            onKeyDown={(e) => handleKeyDown(e)}
        >
            <Box style={{maxWidth: "450px", height: "100%"}}>
                <Grid container>
                    <Grid item xs={8}>
                        <FilterDrawerTitle>
                            More Filters
                        </FilterDrawerTitle>
                    </Grid>
                </Grid>
                <Grid container style={{paddingLeft: "1rem", paddingRight: "1rem"}}>
                    <Grid item xs={12}>
                        <FilterTitle> 
                            Date Range
                        </FilterTitle>
                        <FilterTimeRange
                            lowerBound={props.filter.dateLowerBound}
                            upperBound={props.filter.dateUpperBound}
                            setLowerBound={(value) => props.setFilter((prev: any) => {return {...prev, dateLowerBound: value}})}
                            setUpperBound={(value) => props.setFilter((prev: any) => {return {...prev, dateLowerBound: value}})}
                        />
                    </Grid>
                    <FilterDrawerMoreTextField
                        title="Exception name"
                        value={props.filter.exceptionName}
                        setValue={(value) => {props.setFilter({...props.filter, exceptionName: value})}}
                    />
                    <FilterDrawerMoreTextField
                        title="Exception message"
                        value={props.filter.exceptionMessage}
                        setValue={(value) => {props.setFilter({...props.filter, exceptionMessage: value})}}
                    />
                    <FilterDrawerMoreTextField
                        title="HTTP"
                        value={props.filter.httpCode}
                        setValue={(value) => {props.setFilter({...props.filter, httpCode: value})}}
                    />
                    <FilterDrawerMoreTextField
                        title="Path"
                        value={props.filter.path}
                        setValue={(value) => {props.setFilter({...props.filter, path: value})}}
                    />
                </Grid>
                <Box style={{paddingBottom: "2rem"}} />
                <GridButtons style={{position: "absolute"}} container>
                    <Grid item xs={6} >
                        <BoxButton>
                            <ButtonLightGray
                                onClick= {handleOnClick}
                                variant='text'
                                color="primary"
                                style={{height: "100%", width: "100%"}}
                            >
                                Clear filter
                            </ButtonLightGray>
                        </BoxButton>
                    </Grid>
                    <Grid item xs={6}>
                        <BoxButton>    
                            <ButtonGradient
                                onClick={() => props.onFilterApply(props.filter)}
                                variant='contained'
                                color="primary"
                                style={{height: "100%", width: "100%"}}
                            >
                                Apply
                            </ButtonGradient>
                        </BoxButton>
                    </Grid>
                </GridButtons>
            </Box>
        </Drawer>
    )
}

export default ExceptionDrawerMoreFilter